import { Badge } from '@mantine/core'

// If cannot be detected, reported as unknown in the device attributes
const DEEP_STREAM_UNKNOWN_VERSION = 'unknown'

type DeepStreamVersionBadgeProps = {
  version?: string
}

export const DeepStreamVersionBadge = ({
  version
}: DeepStreamVersionBadgeProps) => {
  if (!version || version.toLowerCase() === DEEP_STREAM_UNKNOWN_VERSION) {
    return null
  }

  return (
    <Badge size="sm" color="gray">
      {version}
    </Badge>
  )
}
